import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'overview.report.card',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'workstream.bar.chart',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.team',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'type.bar.chart',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'anticipated.response.of.change',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.bar.chart',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'anticipated.response.of.change.by.workstream',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'anticipated.response.of.change.by.team',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.by.workstream',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.by.team',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'communications.needed.by.workstream',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'training.implications.by.workstream',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.validation.status',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'high.risk.table',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
        ],
      },
    },
    description: 'Dashboard view for change impact reporting',
    name: 'Change Impacts Dashboard',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
